module.exports = __webpack_public_path__ + "img/dashboad.23cc95de.svg";